module.exports = __webpack_public_path__ + "3ff5b64623fc9d9ae82bb0012ba1ebfb.jpg";